import { decayContent } from "./decayContent"

const headingClass =
  "text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8"

export default function DecaySection() {
  return (
    <section className="flex w-full translate-x-[calc(50vw-50%-1.5rem)] flex-col gap-8">
      <div className="flex flex-col gap-3">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">{decayContent.eyebrow}</p>
        <h2 className={headingClass}>{decayContent.title}</h2>
      </div>
      <ul className="m-0 flex w-full flex-col gap-4 rounded-[2px] border border-solid border-[#E6E6E6] bg-white p-6">
        {decayContent.rows.map((row) => (
          <li key={row.label} className="text-[16px] font-normal leading-6 text-[#4D4D4D]">
            <span className="font-bold text-[#171717]">{row.label}</span> {row.detail}
          </li>
        ))}
      </ul>
      <blockquote className="m-0 flex max-w-[68ch] flex-col gap-3">
        <p className="text-[18px] font-normal italic leading-7 text-[#171717]">“{decayContent.quote}”</p>
        <footer className="text-[14px] font-bold leading-5 text-[#171717]">
          — {decayContent.attribution}
        </footer>
      </blockquote>
    </section>
  )
}
